<template>
    <div >
		<el-dialog
			customClass="customWidth"
		      :visible.sync="videoplay"
		    >
            <div style="display: block;" class="microvideo">
                <div style="width: 100%;" class="microvideoboxright">
                        <div class="list">
                            <ul>
                                <li v-for="(item,index) in list1" :key="index">
                                    <img :src="item.show_image" alt="item.title">
                                    <div class="create" @click="selectVideo(item.id, item.show_image)"><div><p>选择模板</p></div></div>
                                </li>
                            </ul>
                        </div>
						<el-pagination
						style="margin-top: 20px;"
						  background
						  :page-size="12"
						  @size-change="handleSizeChange"
						  @current-change="handleCurrentChange"
						  :current-page="form.page"
						  layout="prev, pager, next"
						  :total="total">
						</el-pagination>
                </div>
            </div>
		</el-dialog>
    </div>
</template>

<script>
import toptab from "@/components/toptab"
import asidebar from "@/components/asidebar"
import microvideom from "@/components/microvideom"
import microvideoD from "@/components/microvideoD"
import {videoGetListV2,videoCollect} from "@/api/video"
export default {
    components: {
        toptab,
        asidebar,
        microvideom,
        microvideoD,
    },
    data(){
        return{
			videoplay:false,
            status:true,
            form:{
                page:1,
            },
			total:0,
            tabindex:0,
            swiperIndex:0,
            swiperOption:{
                // slidesPerView:15,
                spaceBetween : 8,
                slidesPerView: "auto",
                navigation:{
                    prevEl:'.swiper-prev',
                    nextEl:'.swiper-next',
                },
                on: {
                    click: (e) =>  {
                        this.swiperClick(e)
                    }
                }
            },
            swiperdata:[

            ],
			aid:0,
            list1:[],
            tid:1,
        }
    },
    mounted(){
		if (this.$route.query.aid != undefined && this.$route.query.aid != "" && this.$route.query.aid != "0") {
			this.aid = this.$route.query.aid;
		}
        this.videoGetList()
    },
    methods:{
        closelogin(){
            this.loginbox = false
        },
		openDialog(){
		    this.videoplay = true
		},
		handleSizeChange(val) {
		    this.form.page = 1
		    this.videoGetList()
		},
		handleCurrentChange(val) {
		    this.form.page = val
		    this.videoGetList()
		},
		jumpCustomized() {
			this.$router.push({ path: '/customized'});
		},
        selectVideo(id, img){
            // this.tid = id
            // this.status=false
			// if(this.aid > 0 ) {
			// 	this.$router.push({ path: '/digital?tid=' + id + '&aid=' + this.aid});
			// }else {
			// 	this.$router.push({ path: '/digital?tid=' + id});
			// }
			this.videoplay = false;
			this.$emit("colsechatbox", id, img);
        },
        videoGetList(){
            videoGetListV2(this.form).then(res=>{
                this.list1 = res.data.data
				this.total = res.data.total;
            })
        },
        swiperClick(e){
            if(e.target.getAttribute('data-index')){
                if(e.target.getAttribute('data-index')==-1){
                    this.form.cid = 0
                    this.form.collect = 1
                }else{
                    this.form.cid = e.target.getAttribute('data-index')
                    this.form.collect = 0
                }
                this.swiperIndex = e.target.getAttribute('data-index')
                this.videoGetList()
            }
        },
        videoCollect(id,index){
            videoCollect({tid:id}).then(res=>{
                if(res.code==0){
                    if(this.list1[index].collect){
                        this.list1[index].collect = 0
                    }else{
                        this.list1[index].collect = 1
                    }
                }
                this.$message(res.message);
            })
        },
    }
}
</script>

<style lang="less">
    .microvideo{
        .microvideoboxright{
            padding: 30px 20px 0;
            .microvideoheader{
                .title{
                    font-size: 36px;
                    font-weight: 700;
                    color: #191919;
                    text-align: center;
                }
                .tab{
                    padding: 20px 0;
                    border-bottom: 1px solid #e6e9ed;
                    margin: auto;
                    ul{
                        display: flex;
                        gap: 20px;
                        justify-content: center;
                        li{
                            font-size: 16px;
                            font-weight: 700;
                            height: 46px;
                            width: 160px;
                            background: #fff;
                            border: 1px solid #dfeaff;
                            border-radius: 23px;
                            cursor: pointer;
                            position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .on{
                            color: #fff;
                            background: linear-gradient(90deg,#33adff 0%,#1a7af8 99%);
                            border: 0;
                        }
                        .on::after{
                            content: "";
                            position: absolute;
                            bottom: -30px;
                            left: 50%;
                            width: 18px;
                            height: 18px;
                            border-top: 1px solid #e6e9ed;
                            border-left: 1px solid #e6e9ed;
                            transform: translate(-50%) rotate(45deg);
                            z-index: 100;
                        }
                    }
                }
            }
            .swiperbox{
                position: sticky;
                top: 0;
                background-color: #fff;
                z-index: 100;
            }
            .swiper{
                width: 100%;
                position: relative;
                margin-top: 40px;
                height: 34px;
                span{
                    display: block;
                    width: 100%;
                    height: 100%;
                    line-height: 28px;
                }
            }
            .swiper:hover .swiper-prev,.swiper:hover .swiper-next{
                opacity: 1;
            }
            .swiper-container{
                align-items: center;
                margin-left: 0;
                margin-right: 0;
                
            }
            .swiper-slide{
                // max-width: 100px;
                width: 80px;
                height: 30px;
                text-align: center;
                // padding: 5px 12px;
                border: 1px solid #f4f5f7;
                border-radius: 6px;
                background: #fff;
                flex-shrink: 0;
                cursor: pointer;
                position: relative;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .swiperOn{
                border-color: #2d8af5;
                background: #fff;
                color: #2d8af5;
            }
            .swiper-next{
                position: absolute;
                z-index: 100;
                width: 20px;
                height: 100%;
                border-radius: 8px 0 0 8px;
                cursor: pointer;
                background: rgba(0,0,0,.4);
                color: #fff;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                -webkit-transform: translateZ(0);
                opacity: 0;
                svg{
                    width: 14px !important;
                    height: 14px !important;
                }
            }
            .swiper-prev{
                position: absolute;
                z-index: 100;
                width: 20px;
                height: 100%;
                border-radius: 0 8px 8px 0;
                cursor: pointer;
                background: rgba(0,0,0,.4);
                color: #fff;
                left: 0;
                top: 0%;
                display: flex;
                align-items: center;
                justify-content: center;
                -webkit-transform: translateZ(0);
                opacity: 0;
                svg{
                    width: 14px !important;
                    height: 14px !important;
                }
            }
        }
        .list{
            padding-top: 20px;
            ul{
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                li{
                    border-radius: 8px;
                    overflow: hidden;
                    position: relative;
                    cursor: pointer;
                }
                li:hover{
                    .star{
                        display: flex;
                    }
                    .create{
                        display: block;
                    }
                }
                img{
                    width: 100%;
                    display: block;
                }
                div{
                    position: absolute;
                }
                .star{
                    top: 10px;
                    right: 10px;
                    width: 28px;
                    height: 28px;
                    font-size: 16px;
                    border-radius: 4px;
                    background: rgba(0,0,0,.7);
                    color: #fff;
                    align-items: center;
                    justify-content: center;
                    display: none;
                }
                .create{
                    bottom: 30px;
                    transform: translateX(-50%);
                    width: 120px;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                    border-radius: 18px;
                    background: rgba(0,0,0,.8);
                    color: #fff;
                    display: none;
                    div{
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    p{
                        position: relative;
                        z-index: 11;
                        width: 120px;
                        height: 36px;
                        line-height: 36px;
                        text-align: center;
                        border-radius: 18px;
                        background: rgba(0,0,0,.8);
                        color: #fff;
                    }
                    div::after{
                        content: "";
                        display: block;
                        width: 124px;
                        height: 40px;
                        position: absolute;
                        top: -2px !important;
                        left: -2px !important;
                        inset: 0;
                        z-index: -10;
                        border-radius: 50px;
                        background-image: linear-gradient(106.92deg, rgb(16, 197, 254) 14.83%, rgb(16, 147, 254) 31.52%, rgb(79, 79, 231) 65.11%, rgb(182, 12, 185) 91.29%, rgb(224, 202, 245) 102.83%)
                    }
                }
            }
        }
        .tip{
            color: #999;
            font-size: 12px;
            text-align: center;
            margin-top: 12px;
        }
    }
	 .customWidth{
	        width:80%;
	    }
</style>